<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!nuveiCard">
      <span class="loader"></span>
    </span>
    <div v-if="nuveiCard" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="nuveiCard"
      >
        <tab-pane title="nuveiCard" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <nuvei-card-view-global
            :nuveiCard="nuveiCard"
            @onContractUpdated="get"
          />
        </tab-pane>
        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <nuvei-card-view-logs :nuveiCard="nuveiCard" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import NuveiCardViewLogs from "../partials/NuveiCardViewLogs.vue";
import NuveiCardViewGlobal from "../partials/NuveiCardViewGlobal.vue";
export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    NuveiCardViewLogs,
    NuveiCardViewGlobal,
  },

  mixins: [],

  props: {
    nuveiCardId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      nuveiCard: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("nuveiCards/get", this.nuveiCardId);
        this.nuveiCard = this.$store.getters["nuveiCards/nuveiCard"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
